import { render } from "./Saturation.vue?vue&type=template&id=5310dbb4&scoped=true&ts=true"
import script from "./Saturation.vue?vue&type=script&lang=ts"
export * from "./Saturation.vue?vue&type=script&lang=ts"

import "./Saturation.vue?vue&type=style&index=0&id=5310dbb4&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5310dbb4"]])

export default __exports__